import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/employees/$employeeId')({
  component: EmployeeLayout,
});

function EmployeeLayout() {
  return <Outlet />;
}
